import {
  Appointment,
  AppointmentsGroupedByDay,
} from '../../../../../../gql/graphql';
import { Heading } from '../../../../../../ui/components/Heading/Heading';
import { AppointmentCardCompact } from '../../../AppointmentCardCompact/AppointmentCardCompact';
import styles from './AppointmentsGroupedByDay.module.scss';

export const AppointmentsGroupedByDayView = ({
  day,
  appointments,
}: AppointmentsGroupedByDay) => {
  const renderAppointment = (appointment: Appointment) => {
    return <AppointmentCardCompact {...appointment} />;
  };

  const renderAppointments = () => {
    return appointments.map((appointment) => renderAppointment(appointment));
  };
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Heading headingLevel="h3" className={styles.heading}>
          {day}
        </Heading>
      </div>
      <div className={styles.content}>{renderAppointments()}</div>
    </div>
  );
};
